import * as React from "react";

import { UILocation } from "@1js/acui-common";
import type { AppIconPreviewGalleryProps } from "@1js/acui-gallery-icon";
import type { AppIcons } from "@1js/acui-icons";
import type { ControlInMenuRendererFunction } from "@1js/acui-menu";

import {
  convertRibbonPreviewGalleryToFlyoutAnchorProps,
  RibbonIconPreviewGallery,
} from "../Controls/RibbonGallery";
import { getDefaultRibbonFlyoutAnchorRenderer } from "./getDefaultRibbonFlyoutAnchorRenderer";

export function getDefaultIconPreviewGalleryRenderer(
  appIcons: AppIcons,
  controlInMenuRendererFunction: ControlInMenuRendererFunction
) {
  return (props: AppIconPreviewGalleryProps) => {
    if (props.renderAsFlyout) {
      return getDefaultRibbonFlyoutAnchorRenderer(
        appIcons,
        controlInMenuRendererFunction
      )(convertRibbonPreviewGalleryToFlyoutAnchorProps(props));
    }
    return (
      <RibbonIconPreviewGallery
        {...props}
        controlInMenuRendererFunction={controlInMenuRendererFunction}
        downChevronIcon={appIcons.downChevron}
        location={props.location || UILocation.Ribbon}
      />
    );
  };
}
